import axiosHandler from "../../Intersepter/axiosInstance";

// Fetch tickets API function
export const fetchQuiz = async () => {
  try {
    const response = await axiosHandler.get(`/question`);
    return response;
  } catch (error) {
    console.error("Error fetching quiz:", error);
    throw error;
  }
};
